import React from "react";
import {
  Button,
  Card,
  CardContent,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { shiftDate, toInputDate } from "./agendaDateUtils";

export default function AgendaFilters({
  selectedDate,
  onDateChange,
  sourceFilter,
  onSourceFilterChange,
  sourceOptions = [],
}) {
  return (
    <Card sx={{ borderRadius: 4 }}>
      <CardContent>
        <Stack
          direction={{ xs: "column", lg: "row" }}
          spacing={2}
          alignItems={{ xs: "stretch", lg: "center" }}
          justifyContent="space-between"
        >
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1} alignItems={{ xs: "stretch", sm: "center" }}>
            <Typography variant="subtitle2" sx={{ minWidth: 82 }}>
              Day View
            </Typography>
            <Button variant="outlined" onClick={() => onDateChange(shiftDate(selectedDate, -1))}>
              Previous
            </Button>
            <TextField
              type="date"
              size="small"
              value={toInputDate(selectedDate)}
              onChange={(event) => onDateChange(event.target.value)}
              InputLabelProps={{ shrink: true }}
            />
            <Button variant="outlined" onClick={() => onDateChange(toInputDate(new Date()))}>
              Today
            </Button>
            <Button variant="outlined" onClick={() => onDateChange(shiftDate(selectedDate, 1))}>
              Next
            </Button>
          </Stack>

          <TextField
            select
            size="small"
            label="Source"
            value={sourceFilter}
            onChange={(event) => onSourceFilterChange(event.target.value)}
            sx={{ minWidth: 180 }}
          >
            {sourceOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Stack>
      </CardContent>
    </Card>
  );
}
